import { Conversion } from '@piano/types/pianoTp';

export const collectEndedSubscriptions = (conversions: Conversion[]): string[] => {
  return [
    ...new Set(
      conversions.filter((conversion) => conversion.type === 'Subscription' && !conversion.user_access.granted).map((conversion) => conversion.term.term_id)
    ),
  ];
};
